"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _scene7UrlParser = require("../../../utils/scene7/scene7UrlParser");
var _imageModule = _interopRequireDefault(require("./image.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Image = function Image(_ref) {
  var _ref$alternativeImage = _ref.alternativeImageUrls,
    alternativeImageUrls = _ref$alternativeImage === void 0 ? [] : _ref$alternativeImage,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 0.75 : _ref$aspectRatio,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
    _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
    hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$imageRef = _ref.imageRef,
    imageRef = _ref$imageRef === void 0 ? undefined : _ref$imageRef,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
    _ref$multipleSwatches = _ref.multipleSwatches,
    multipleSwatches = _ref$multipleSwatches === void 0 ? false : _ref$multipleSwatches,
    _ref$selectedSwatch = _ref.selectedSwatch,
    selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
    _ref$sizes = _ref.sizes,
    sizes = _ref$sizes === void 0 ? '(max-width: 567px) 50vw, (min-width: 568px) and (max-width:768px) 33vw, 20vw' : _ref$sizes,
    _ref$srcSetWidths = _ref.srcSetWidths,
    srcSetWidths = _ref$srcSetWidths === void 0 ? ['160', '320', '540'] : _ref$srcSetWidths,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url;
  var imageUrl = multipleSwatches && selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.imageUrl ? selectedSwatch.imageUrl : image;
  var hasAlternativeImages = (alternativeImageUrls === null || alternativeImageUrls === void 0 ? void 0 : alternativeImageUrls.length) > 0 && ((0, _isEmpty["default"])(selectedSwatch) || (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.imageUrl) === image);
  var isAltImageOnHoverEnabled = hasAltImageOnHover && hasAlternativeImages;
  var determineSrcSetArr = function determineSrcSetArr(urlOfImage) {
    return srcSetWidths.map(function (width) {
      return "".concat((0, _scene7UrlParser.setScene7UrlQueryParams)(urlOfImage, {
        wid: width,
        hei: Math.round(width / aspectRatio)
      }), " ").concat(width, "w");
    });
  };
  var srcSetArr = determineSrcSetArr(imageUrl);
  var altImageSrcSetArr = hasAlternativeImages ? determineSrcSetArr(alternativeImageUrls[0]) : [];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
    className: (0, _classnames["default"])(_imageModule["default"].imageLink, className),
    href: url,
    tabIndex: "-1",
    "aria-hidden": "true",
    onClick: handleClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: (0, _classnames["default"])(_imageModule["default"].image),
      width: "250",
      height: Math.round(250 / aspectRatio),
      src: srcSetArr[0].split(' ')[0],
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      srcSet: srcSetArr.join(', '),
      sizes: sizes,
      ref: imageRef,
      loading: loading,
      "data-test": "product-card-image"
    }), isAltImageOnHoverEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: (0, _classnames["default"])(_imageModule["default"].altImage),
      width: "250",
      height: Math.round(250 / aspectRatio),
      src: altImageSrcSetArr[0].split(' ')[0],
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      srcSet: altImageSrcSetArr.join(', '),
      sizes: sizes,
      loading: loading,
      "data-test": "product-card-alt-image"
    }) : null]
  });
};
Image.propTypes = {
  alternativeImageUrls: _propTypes["default"].arrayOf(_propTypes["default"].string),
  aspectRatio: _propTypes["default"].number,
  className: _propTypes["default"].string,
  handleClick: _propTypes["default"].func,
  hasAltImageOnHover: _propTypes["default"].bool,
  image: _propTypes["default"].string,
  loading: _propTypes["default"].oneOf(['eager', 'lazy']),
  multipleSwatches: _propTypes["default"].bool,
  selectedSwatch: _propTypes["default"].shape({
    color: _propTypes["default"].string,
    basicColor: _propTypes["default"].string,
    colorSwatchUrl: _propTypes["default"].string,
    imageUrl: _propTypes["default"].string,
    isAvailable: _propTypes["default"].bool,
    skuId: _propTypes["default"].string,
    id: _propTypes["default"].string,
    isColorOfDefaultVariant: _propTypes["default"].bool,
    url: _propTypes["default"].string
  }),
  sizes: _propTypes["default"].string,
  srcSetWidths: _propTypes["default"].arrayOf(_propTypes["default"].string),
  title: _propTypes["default"].string,
  url: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Image);